import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const FolderOpen = ({
  height = 24,
  width = 24,
  color = colors.cyan50,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-test="folder-open-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M20.4232 12.3262C20.4446 12.2177 20.4416 12.1058 20.4147 11.9985C20.3877 11.8912 20.3373 11.7912 20.2671 11.7057C20.1969 11.6202 20.1087 11.5513 20.0087 11.5038C19.9088 11.4564 19.7996 11.4317 19.689 11.4315H10.818C10.6453 11.4312 10.4781 11.3713 10.3445 11.262C10.2108 11.1527 10.119 11.0006 10.0845 10.8315L9.87597 9.78823C9.84145 9.61908 9.74962 9.46702 9.61599 9.35771C9.48236 9.2484 9.31511 9.18854 9.14247 9.18823H4.31022C4.19966 9.18859 4.09055 9.21338 3.99069 9.26084C3.89083 9.30829 3.8027 9.37724 3.73261 9.46274C3.66252 9.54825 3.61219 9.64819 3.58524 9.75542C3.55829 9.86264 3.55538 9.9745 3.57672 10.083L5.52147 19.833C5.556 20.0021 5.64783 20.1542 5.78146 20.2635C5.91509 20.3728 6.08233 20.4327 6.25497 20.433H18.1935C18.3661 20.4327 18.5334 20.3728 18.667 20.2635C18.8006 20.1542 18.8924 20.0021 18.927 19.833C19.2352 18.294 20.058 14.1517 20.4232 12.3262Z"
      fill={getColor(color, isColorInherited)}
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.39 6L6.39001 4.3125C6.39001 4.11359 6.46903 3.92282 6.60968 3.78217C6.75034 3.64152 6.9411 3.5625 7.14001 3.5625H16.8623C17.0612 3.5625 17.2519 3.64152 17.3926 3.78217C17.5332 3.92282 17.6123 4.11359 17.6123 4.3125V8.5"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
